import { faBox } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext } from "react";
import { Button, Container, Form, Spinner, Stack } from "react-bootstrap";
import { ItemOrcamentoVendaContext } from "../../contexts/itemorcamentovenda-context";
import { useFormikContext } from "formik";
import { GetConfiguracoes } from "../../config/localstorageConfig/localstorage";

const SelecaoProdutoCtx = () => {

    const {
        loadingGlobal,
        setModalComposicao
    } = useContext(ItemOrcamentoVendaContext);

    const configGeral = GetConfiguracoes();

    const {
        values,
        setFieldValue,
        resetForm,
        handleChange
    } = useFormikContext();

    return (
        <Container>
            <Stack direction="horizontal" gap={2}>
                <div
                    className="p-0 flex-grow-1"
                >

                    <Form.Control
                        name={"ItemOrcamentoVenda.NomeProduto"}
                        className="me-auto"
                        value={values.ItemOrcamentoVenda?.NomeProduto}
                        onChange={handleChange}
                        type="text"
                        placeholder={""}
                        // style={{ flex: 10 }}
                        disabled
                    />


                </div>
                {configGeral?.ConfiguracaoWeb?.ExibirComposicaoProduto !== false && <div
                    className="p-0"
                >
                    {loadingGlobal ? <Spinner animation="border" size="10" variant="secondary" /> : <Button
                        variant="outline-secondary"
                        disabled={!values.ItemOrcamentoVenda?.CodProduto}
                        type="button"
                        onClick={(e) => {
                            setModalComposicao(true);

                        }}
                        style={{ width: 60, alignContent: "bottom" }}
                    >
                        <FontAwesomeIcon icon={faBox}></FontAwesomeIcon>
                    </Button>}

                </div>}



            </Stack>
        </Container>
    )
}

export default SelecaoProdutoCtx;

